import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  Button,
  Popover,
  message,
  Badge,
  Switch,
  Popconfirm,
  Table,
} from "antd";
import {
  DeleteFilled,
  CheckOutlined,
  CloseOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import QRManagementStatisticsModal from "./QRManagementStatisticsModal";

import { url } from "./QRManagementScanner";
import qrActions from "../../../redux/qr/actions";
import { arrayMoveElementsByIndex } from "../../../utils/utility";

const { deleteQRTable, dispatchSetTableStatus } = qrActions;

const QRManagementTable = ({ searchedValue }) => {
  const dispatch = useDispatch();
  const [openStatisticsModal, setOpenStatisticsModal] = useState(false);
  const [columnRecord, setColumnRecord] = useState({});
  const { tables } = useSelector((state) => state.qrReducer);
  const { selectedRestaurant } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );
  const { syncImageInProgress } = useSelector(
    (state) => state.menuConfigurationReducer
  );

  const selectedRestarauntTable = tables.filter(
    (table) => table.restaurantId === selectedRestaurant
  );

  const currentDay = dayjs();
  const oneMonthBack = currentDay.subtract(1, "month");

  const showVisitsLast30days = (record) =>
    record?.statistics?.visits
      ?.map((item) =>
        arrayMoveElementsByIndex(item.split(" ")[0].split("-"), 0, 1).join("-")
      )
      ?.map((item) => {
        const parts = item.split("-");
        if (parts.length >= 3) {
          const formattedDate = `${parts[2]}-${parts[0]}-${parts[1]}`;
          return dayjs(formattedDate);
        }
        return dayjs(item);
      })
      ?.filter((item) => item <= currentDay && item >= oneMonthBack)?.length;

  const updateSelectedRestarauntTable = selectedRestarauntTable.map((obj) => {
    const visitsLast30Days = showVisitsLast30days(obj) || 0;
    return { ...obj, visitsLast30Days: visitsLast30Days };
  });

  const filteredDataSource =
    searchedValue.length === 0
      ? updateSelectedRestarauntTable
      : updateSelectedRestarauntTable.filter((item) => {
          const tableName = item.name.toLowerCase();
          return tableName.includes(searchedValue.toLowerCase());
        });

  const columns = [
    {
      title: "Маса",
      dataIndex: "name",
      rowKey: "name",
      width: "20%",
      sorter: (a, b) => +a.name - +b.name,
      key: "name",
      render: (text) => (
        <span className="qr-management-table-text">{text}</span>
      ),
    },
    {
      title: "Сканирания (последния месец)",
      rowKey: "visitsLast30Days",
      dataIndex: "visitsLast30Days",
      key: "visitsLast30Days",
      width: "25%",
      sorter: (a, b) => a.visitsLast30Days - b.visitsLast30Days,
      render: (text, record) => (
        <div
          onClick={() => {
            setOpenStatisticsModal(true);
            setColumnRecord(record);
          }}
          className="
        qr-management-table-text
        qr-management-scanning-column-container 
        pointer-cursor"
        >
          <p>{text}</p>
          <p>
            Виж <BarChartOutlined />
          </p>
        </div>
      ),
    },
    {
      title: "Дата на създаване",
      dataIndex: "created",
      rowKey: "created",
      width: "25%",
      align: "center",
      key: "created",
      render: (text) => (
        <span className="qr-management-table-text">
          {dayjs(text).format("DD-MM-YYYY HH:mm:ss")}
        </span>
      ),
    },
    {
      title: "Статус",
      dataIndex: "view",
      rowKey: "view",
      width: "15%",

      render: (text, table) => (
        <div className="qr-management-table-text">
          <Badge status="warning" text="" />
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            onChange={(status) => {
              dispatch(dispatchSetTableStatus(table.identifier, status));
            }}
            checked={table.active}
            className="qr-management-table-status-field"
          />
          <Badge status="success" text="" />
        </div>
      ),
    },
    {
      title: "Информация",
      dataIndex: "view",
      rowKey: "view",
      width: "15%",

      render: (text, table) => (
        <div className="qr-management-table-action-button ">
          <Popover content={table.identifier} trigger="hover">
            <a target="_blank" rel="noreferrer" href={url() + table.identifier}>
              <Button
                onClick={() => {
                  navigator.clipboard.writeText(url() + table.identifier);
                  message.success("Копирано");
                }}
              >
                guid
              </Button>
            </a>
          </Popover>

          <Popconfirm
            title="Сигурен ли сте？"
            okText="Да"
            cancelText="Не"
            onConfirm={() => dispatch(deleteQRTable(table))}
          >
            <Button className="qr-management-table-delete-icon">
              <DeleteFilled />
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <>
      <QRManagementStatisticsModal
        openStatisticsModal={openStatisticsModal}
        setOpenStatisticsModal={setOpenStatisticsModal}
        columnRecord={columnRecord}
      />
      {updateSelectedRestarauntTable === undefined || (
        <div className="qr-management-table-container">
          <Table
            loading={
              updateSelectedRestarauntTable === undefined || syncImageInProgress
            }
            className="qr-management-table"
            rowKey="identifier"
            key="qr-management-table"
            dataSource={filteredDataSource}
            columns={columns}
            pagination={{
              defaultPageSize: 50,
              showSizeChanger: true,
              pageSizeOptions: ["10", "25", "50", "100"],
            }}
          />
        </div>
      )}
    </>
  );
};

export default QRManagementTable;
